import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./NotFound.css";

export const NotFound = () => {
    const location = useLocation();

    return (
        <div className="not-found-page">
            <Helmet>
                <title>404 - mustardtiger.xyz</title>
                <meta
                    name="description"
                    content="The requested page could not be found."
                />
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="404 - mustardtiger.xyz"
                />
                <meta
                    property="og:description"
                    content="The requested page could not be found."
                />
                <meta
                    property="og:image"
                    content="https://mustardtiger.xyz/og-image.png"
                />
            </Helmet>

            <div className="not-found-shell">
                <div className="not-found-glow not-found-glow-left" />
                <div className="not-found-glow not-found-glow-right" />

                <div className="terminal-window not-found-terminal">
                    <div className="terminal-output">
                        <div className="prompt-line">
                            <span className="prompt">$</span>
                            <span className="command">cat 404.log</span>
                        </div>

                        <div className="not-found-badge">404</div>

                        <h1>Path not found</h1>
                        <p className="not-found-message">
                            The terminal looked for{" "}
                            <span className="not-found-path">
                                {location.pathname}
                            </span>{" "}
                            and came back empty-handed.
                        </p>

                        <div className="not-found-panel">
                            <div className="not-found-line">
                                <span className="not-found-label">
                                    status:
                                </span>
                                <span className="not-found-value">
                                    lost in the filesystem
                                </span>
                            </div>
                            <div className="not-found-line">
                                <span className="not-found-label">
                                    suggestion:
                                </span>
                                <span className="not-found-value">
                                    navigate home or browse posts
                                </span>
                            </div>
                            <div className="not-found-line">
                                <span className="not-found-label">
                                    cursor:
                                </span>
                                <span className="not-found-value">
                                    <span className="cursor not-found-cursor" />
                                </span>
                            </div>
                        </div>

                        <div className="not-found-actions">
                            <Link to="/" className="not-found-button">
                                cd ~
                            </Link>
                            <Link to="/posts" className="not-found-button">
                                ls posts/
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
